// extracted by mini-css-extract-plugin
export default {"wrapper":"JGP4R","imgWrapper":"s_lnS","image":"Buwih","titleWrap":"xPWAi","title":"QZmRH","count":"yGQ0W","discount":"kGsHK","big":"ZFbxV","longPrice":"ANHhQ","small":"cknZZ"};